import React from "react";
import ImagePartitionLayout from "../../layout/imagepartitionlayout/imagepartitionlayout";

import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";

import ConfirmResetPasswordForm from "./components/confirmresetpasswordform";
import {RESET_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";

class ConfirmResetPassword extends React.Component {
    render() {
        return (
            <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<ConfirmResetPasswordForm/>} titleLabel={"Reset Password"}/>}
                                  title={WEBSITE_TITLE}
                                  subtitle={
                                      ""}
            />
        );
    }
}

export default ConfirmResetPassword;



